<div class="h-full min-h-dvh w-full overflow-y-auto bg-zinc-100 dark:bg-zinc-950">
    <div class="mx-auto flex w-full max-w-7xl flex-col gap-6 p-4 sm:p-6">
        <header
            class="flex flex-col gap-4 border-b border-zinc-200 pb-4 sm:flex-row sm:items-center sm:justify-between dark:border-zinc-800">
            <div class="flex min-w-0 items-center gap-4">
                <img src="../assets/logos/official/SHOUT_studio_logo_full_colour_black.svg"
                    class="h-8 dark:hidden" alt="SHOUT Studio">
                <img src="../assets/logos/official/SHOUT_studio_logo_full_colour_white.svg"
                    class="hidden h-8 dark:block" alt="SHOUT Studio">
                <div class="hidden h-8 w-px shrink-0 bg-zinc-200 sm:block dark:bg-zinc-800"></div>
                <div class="min-w-0">
                    <p class="m-0 text-xs font-medium uppercase tracking-wide text-secondary">Creator shortlist</p>
                    <p class="m-0 text-sm text-secondary">Approve, decline, or leave feedback. No account needed.</p>
                </div>
            </div>

            @if (canWrite()) {
            <div class="w-full sm:max-w-xs sm:flex-none">
                <label for="reviewer-first-name" class="block text-sm font-medium text-primary">Your first
                    name</label>
                <input id="reviewer-first-name" type="text" name="given-name" autocomplete="given-name"
                    [attr.maxlength]="reviewerNameMaxLength" [value]="reviewerName()"
                    (input)="onReviewerNameInput($event)" placeholder="e.g. Sarah"
                    [class.outline]="nameNeeded()" [class.outline-2]="nameNeeded()"
                    [class.outline-red-500]="nameNeeded()" [attr.aria-invalid]="nameNeeded()"
                    [attr.aria-describedby]="nameNeeded() ? 'reviewer-first-name-help reviewer-first-name-hint' : 'reviewer-first-name-help'"
                    class="input-primary mt-1 w-full text-primary">
                <p id="reviewer-first-name-help" class="mt-1 text-xs text-secondary">Shown next to approve and
                    decline.</p>
                @if (nameNeeded()) {
                <p id="reviewer-first-name-hint" class="mt-1 text-xs text-error-light">Add your first name so they
                    know who reviewed.</p>
                }
            </div>
            }
        </header>

        @if (loadingState() === 'loading') {
        <div class="flex flex-1 items-center justify-center py-24">
            <p class="m-0 text-sm text-secondary">Loading shortlist…</p>
        </div>
        } @else if (loadingState() === 'error') {
        <div class="flex flex-1 flex-col items-center justify-center py-24 text-center">
            <h1 class="text-base font-semibold text-primary">This shortlist could not be opened</h1>
            <p class="mt-1 max-w-md text-sm text-secondary">The link may be out of date. Ask the sender for a new one.
            </p>
        </div>
        } @else {
        <section class="overflow-hidden rounded-2xl border border-zinc-200 bg-zinc-50 shadow-sm dark:border-zinc-800 dark:bg-zinc-900">
            <div class="flex flex-col gap-5 p-5 sm:p-6">
                <div class="flex flex-col gap-4 lg:flex-row lg:items-start lg:justify-between">
                    <div class="min-w-0">
                        <h1 class="m-0 text-2xl font-semibold tracking-tight text-primary use-grotesque">
                            {{ group()?.groupName }}</h1>
                        @if (visibleDescription()) {
                        <p class="mt-1 text-sm text-secondary">{{ visibleDescription() }}</p>
                        }
                        @if (brandName() || (group()?.approvalStatus === 'approved' && group()?.approvedByName)) {
                        <p class="mt-2 text-sm text-secondary">
                            @if (brandName()) {
                            Shared by {{ brandName() }}
                            }
                            @if (brandName() && group()?.approvalStatus === 'approved' && group()?.approvedByName) {
                            ·
                            }
                            @if (group()?.approvalStatus === 'approved' && group()?.approvedByName) {
                            Approved by {{ group()?.approvedByName }}
                            }
                        </p>
                        }
                    </div>

                    @if (canInviteApproved()) {
                    <p class="m-0 max-w-sm text-sm text-secondary lg:text-right" aria-live="polite">
                        @if (inviting()) {
                        Inviting to {{ inviteBriefTitle() || 'the brief' }}…
                        } @else if (approvedCount() > 0 && approvedForInviteCount() === 0) {
                        Approved creators are invited to {{ inviteBriefTitle() || 'the brief' }}.
                        } @else {
                        Creators you approve will be invited to {{ inviteBriefTitle() || 'this brief' }}.
                        }
                    </p>
                    }
                </div>

                <div class="rounded-lg bg-white p-4 dark:bg-zinc-950/50" aria-live="polite">
                    <div class="flex items-start gap-3">
                        @if (pendingCount() === 0) {
                        <div
                            class="flex size-10 shrink-0 items-center justify-center rounded-full bg-green-100 dark:bg-green-900/40">
                            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none"
                                stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                                class="size-5 text-green-600 dark:text-green-300" aria-hidden="true">
                                <path d="M20 6 9 17l-5-5" />
                            </svg>
                        </div>
                        } @else {
                        <div
                            class="flex size-10 shrink-0 items-center justify-center rounded-full bg-primary/15 text-sm font-semibold tabular-nums text-primary">
                            {{ pendingCount() }}
                        </div>
                        }
                        <div class="min-w-0 flex-1">
                            <div class="flex flex-col gap-1 sm:flex-row sm:items-baseline sm:justify-between">
                                <p class="m-0 text-base font-semibold text-primary">{{ pendingReviewTitle() }}</p>
                                <p class="m-0 text-sm tabular-nums text-secondary">{{ reviewedCount() }} of
                                    {{ creators().length }} reviewed</p>
                            </div>
                            @if (pendingCount() === 0) {
                            <p class="mt-1 text-sm text-secondary">Every creator has been reviewed.</p>
                            } @else {
                            <p class="mt-1 text-sm text-secondary">Approve, decline, or leave feedback to clear this
                                list.</p>
                            }
                            <div class="mt-3 h-1.5 overflow-hidden rounded-full bg-zinc-200 dark:bg-zinc-800"
                                role="progressbar" [attr.aria-valuenow]="reviewedCount()"
                                [attr.aria-valuemin]="0" [attr.aria-valuemax]="creators().length"
                                aria-label="Review progress">
                                <div class="h-full rounded-full transition-all"
                                    [class.bg-primary]="pendingCount() > 0"
                                    [class.bg-green-500]="pendingCount() === 0"
                                    [style.width.%]="reviewProgressPercent()"></div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div
                class="flex flex-col gap-3 border-t border-zinc-200 px-5 py-3 sm:flex-row sm:items-center sm:justify-between sm:px-6 dark:border-zinc-800">
                <p class="m-0 text-sm text-secondary">{{ approvedCount() }} of {{ creators().length }} approved</p>
                <div class="inline-flex w-fit flex-wrap gap-1 rounded-lg bg-zinc-100 p-1 dark:bg-zinc-800"
                    role="group" aria-label="Filter creators by review">
                    @for (tab of reviewFilterTabs(); track tab.id) {
                    <button type="button" [attr.aria-pressed]="isReviewFilterSelected(tab.id)"
                        (click)="setReviewFilter(tab.id)" [class]="reviewFilterButtonClass(tab.id)">
                        {{ tab.label }}
                        <span class="tabular-nums">{{ tab.count }}</span>
                    </button>
                    }
                </div>
            </div>
        </section>

        @if (creators().length === 0) {
        <div class="flex flex-col items-center justify-center py-16 text-center">
            <h2 class="text-sm font-semibold text-primary">No creators in this group</h2>
            <p class="mt-1 text-sm text-secondary">The sender has not added anyone yet.</p>
        </div>
        } @else if (visibleCreators().length === 0) {
        <div class="flex flex-col items-center justify-center py-16 text-center">
            <h2 class="text-sm font-semibold text-primary">{{ emptyFilterCopy().title }}</h2>
            <p class="mt-1 text-sm text-secondary">{{ emptyFilterCopy().message }}</p>
        </div>
        } @else {
        <div class="flex flex-col gap-8">
            @for (creator of visibleCreators(); track creator.blazeFirebaseUid) {
            <app-share-review-creator [creator]="creator" [shareToken]="shareToken()"
                [approved]="isApproved(creator)"
                [declined]="isDeclined(creator)" [invited]="isInvited(creator)"
                [inviteOnApprove]="canInviteApproved()" [reviewLabel]="reviewLabel(creator)"
                [reviewNote]="creatorNote(creator)" (approve)="onApprove(creator)" (decline)="onDecline(creator)"
                (feedback)="onReviewFeedback(creator, $event)"></app-share-review-creator>
            }
        </div>
        }
        }
    </div>
</div>

@if (magicSearchService.portfolioCreatorId()) {
<cc-creator-profile [creator]="magicSearchService.portfolioCreator()!"
    [showFooterActions]="false"></cc-creator-profile>
}

@if (magicSearchService.previewVideo()) {
<atom-single-video-viewer-summary class="z-50" [video]="magicSearchService.previewVideo()!"
    (closePreviewOut)="closeVideoPreview()"></atom-single-video-viewer-summary>
}
